import { autoserializeAs } from 'cerialize';
import { Provider } from './provider';
import { TransitProgram } from './transit-program';
import { ComplianceStatus } from './compliance-status';

export class ProviderDetail {
  @autoserializeAs(Provider)
  provider: Provider;

  @autoserializeAs(ComplianceStatus)
  complianceStatus: ComplianceStatus;

  @autoserializeAs(TransitProgram)
  transitPrograms: Array<TransitProgram>;
}
